module.exports = __webpack_public_path__ + "img/makehuman.70f690b9.png";